@if (show) {
  <span class="error-text text-danger font-size-12">{{ lastErrorLabel }}</span>
}
